import addError from '../../../utils/error.jsx';

export function request(entity, action, id ) {
    return {
        type: 'FRAUD_AND_COMPLIANCE_UPDATE_REQUEST',
        entity,
        action,
        id
    };
}

export function error(id, errors) {
    addError(errors);

    return {
        type: 'FRAUD_AND_COMPLIANCE_UPDATE_ERROR',
        errors,
        id
    };
}

export function finish(id, action) {
    return (dispatch, getState) => {
        dispatch({
            type: 'FRAUD_AND_COMPLIANCE_UPDATE_FINISH',
            action,
            id,
            userId: getState().user.getIn([ 'data', 'id' ])
        });
    };
}
